const backgrounds = {
  dark: {
    default: 'dark',
    values: [
        { name: 'dark', value: 'rgb(24,42,68)' },
    ],
  },
  light: {
    default: 'light',
    values: [
      { name: 'light', value: 'rgb(232,243,252)' },
    ],
  },
};

export default backgrounds;
